class CategorySlider {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-slider-track]');
    this.prevBtn = section.querySelector('[data-slider-prev]');
    this.nextBtn = section.querySelector('[data-slider-next]');

    if (!this.track || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.scrollByAmount(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByAmount(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons());

    this.updateButtons();
  }

  getStep() {
    const slide = this.track.querySelector('.category-slider__slide');
    if (!slide) return this.track.clientWidth;
    const style = getComputedStyle(this.track);
    const gap = parseFloat(style.columnGap || style.gap || 0);
    return slide.getBoundingClientRect().width + gap;
  }

  scrollByAmount(direction) {
    const step = this.getStep();
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    this.prevBtn.disabled = this.track.scrollLeft <= 0;
    this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
  }
}

function initCategorySliders() {
  document.querySelectorAll('.category-slider').forEach((section) => {
    if (section.dataset.sliderInitialized) return;
    section.dataset.sliderInitialized = 'true';
    new CategorySlider(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCategorySliders);
} else {
  initCategorySliders();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.category-slider');
  if (section) {
    delete section.dataset.sliderInitialized;
    new CategorySlider(section);
  }
});
